﻿import { Controller } from "@hotwired/stimulus";
import InfiniteScroll from "infinite-scroll";

export default class extends Controller {
    static get targets() {
        return ["rewards","sortOrderSelection"];
    }

    rewardsTargetConnected(target) {
        new InfiniteScroll(
            target,
            {
                fetchOptions: {
                    headers: {
                        "X-Requested-With": "XMLHttpRequest"
                    }
                },
                path: ".js-load-next",
                append: ".c-item-container",
                history: true,
            }
        )
    }

    setAvailableSortOrder({ target }) {
        const isAllPerkType = target.options[target.selectedIndex].value === "";

        if (isAllPerkType) {
            this.sortOrderSelectionTarget.selectedIndex = 0;
        }

        for (const option of this.sortOrderSelectionTarget.options) {
            if (!option.hasAttribute("data-for-all-perk-types")) {
                option.classList.toggle("d-none", isAllPerkType);
            }
        }
    }
}
